import { Bone } from '../primitives';

// Full-page version of AudioAssets.tsx (shared by SoundEffectsPage/MusicPage) for the
// hard-refresh case, where none of the page's own chrome has mounted yet. Mirrors, top
// to bottom: the title, the Explore/My tabs, the suggestion chips + prompt box, the
// search bar, and the asset-row list. The in-app loading state (once this chrome has
// already mounted) uses the lighter AudioAssetsSkeleton for just the row list instead.
export default function AudioAssetsPageSkeleton() {
    return (
        <div style={{ maxWidth: 1120, width: '100%', margin: '0 auto' }}>
            {/* Title */}
            <Bone h={26} w={160} style={{ marginBottom: 14 }} />

            {/* Tabs */}
            <div style={{ display: 'flex', gap: 20, borderBottom: '1px solid #E2E8F0', marginBottom: 18, paddingBottom: 11 }}>
                <Bone h={14} w={60} />
                <Bone h={14} w={90} />
            </div>

            {/* Suggestion chips + prompt box */}
            <div style={{ maxWidth: 760, margin: '0 auto 26px' }}>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 10 }}>
                    {Array.from({ length: 3 }).map((_, i) => <Bone key={i} h={30} w={140} r={999} />)}
                </div>
                <Bone h={90} r={12} />
            </div>

            {/* Search */}
            <div style={{ display: 'flex', marginBottom: 20 }}>
                <Bone h={36} w={280} r={999} style={{ marginLeft: 'auto' }} />
            </div>

            {/* Asset rows */}
            <div>
                {Array.from({ length: 6 }).map((_, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '9px 12px', borderTop: i > 0 ? '1px solid #F1F5F9' : 'none' }}>
                        <Bone w={40} h={40} r={9} />
                        <Bone h={13} w="45%" />
                        <div style={{ flex: 1 }} />
                        <Bone h={24} w={200} />
                        <Bone h={11} w={60} />
                    </div>
                ))}
            </div>
        </div>
    );
}
